import React from 'react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'types/provider';
import { Header } from 'semantic';
import SignInButtons from './SignInButtons';

export default function SigninSettings({ provider }: { provider?: Provider }) {
  const { t } = useTranslation();

  return (
    <div>
      <Header as="h2">
        {t('provider.signinSettingsTitle', 'Sign In Settings')}
      </Header>
      <p>
        {t(
          'provider.signinSettingsDescription',
          'This section allows you to configure sign-in settings for the provider.'
        )}
      </p>
      <SignInButtons provider={provider} />
    </div>
  );
}
